import React from "react";
import OperationalResource from "../components/OperationalResource";
export default function Settings() {
  return <OperationalResource title="Participation Settings" resource="settings" />;
}
